export enum SwitchState {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	MIDDLE = 'MIDDLE',
}

export type AdvancedSwitchSize = 's' | 'm';

export type AdvancedSwitchJustify = 'flex-start' | 'center' | 'space-between';
export type AdvancedSwitchAlign = 'flex-start' | 'center';
